import { render, staticRenderFns } from "./ItemWidgetMessenger.vue?vue&type=template&id=4e0f94c0&scoped=true&"
import script from "./ItemWidgetMessenger.vue?vue&type=script&lang=js&"
export * from "./ItemWidgetMessenger.vue?vue&type=script&lang=js&"
import style0 from "./ItemWidgetMessenger.vue?vue&type=style&index=0&id=4e0f94c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0f94c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
